import React from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Popover,
  useMediaQuery,
  useTheme,
  Slide,
  SlideProps,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Close } from '@mui/icons-material';


const useStyles = makeStyles()(theme => ({
  mobileHeader: {
    '& h3': {
      fontSize: '26px'
    }
  },
  mobileContent: {
    padding: '0px',
  },
  desktopFooter: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
  },
}));


export const PopoverModalTransition = React.forwardRef(function Transition(
  props: SlideProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export type PopoverModalProps = {
  isOpen: boolean;
  handleClose: () => void;

  title: string;
  footer: React.ReactElement;

  anchorEl?: HTMLElement;
  maxHeight?: string;
  className?: string;
};

export const PopoverModal: React.FC<PopoverModalProps> = ({
  isOpen, handleClose, anchorEl, children, title, footer, maxHeight = '60vh', className,
}) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <Dialog
        fullScreen
        open={isOpen}
        onClose={handleClose}
        TransitionComponent={PopoverModalTransition}
        scroll="paper"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center" className={classes.mobileHeader}>
            <h3>
              {title}
            </h3>
            <IconButton aria-label="close" onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers className={classes.mobileContent}>
          {children}
        </DialogContent>
        <DialogActions>
          {footer}
        </DialogActions>
      </Dialog>
    );
  } else {
    return (
      <Popover
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
        transformOrigin={{ vertical: 'top', horizontal: 'left', }}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{ className }}
      >
        <Box maxHeight={maxHeight} overflow="auto" pb={1}>
          {children}
        </Box>
        <Box className={classes.desktopFooter}>
          {footer}
        </Box>
      </Popover>
    );
  }
};
